export default function CoreLocking() {
  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto">
          <p className="font-serif italic text-plum-dark text-sm md:text-base mb-3">
            Comprendre le mécanisme
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-plum mb-8 leading-tight">
            La crémone : le <span className="font-serif italic">cœur</span> du verrouillage
          </h2>

          <div className="space-y-6 text-plum-dark text-base md:text-lg leading-relaxed">
            <p>
              La crémone est le mécanisme central qui transforme le mouvement de votre poignée en verrouillage ou déverrouillage de la fenêtre. C'est un ensemble de tiges, de galets, de crochets et de ressorts logés dans le dormant (la partie fixe) de la menuiserie. Quand vous tournez la poignée, la crémone actionne simultanément les points de fermeture en haut, en bas et sur le côté — assurant l'étanchéité, la sécurité et la rigidité de l'ouvrant.
            </p>
            <p>
              Avec le temps, les pannes les plus fréquentes sont la rupture de la tige centrale (souvent en zamak), le blocage des galets par manque de lubrification, ou la déformation des crochets par surcompression. Quand la crémone lâche, la fenêtre peut rester bloquée fermée, ne plus verrouiller correctement, ou laisser passer l'air et l'eau. Nos techniciens remplacent la crémone complète ou réparent la pièce défectueuse sur place, que la fenêtre soit en PVC, aluminium ou bois.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}